/**
 * Configuração centralizada da URL da API
 * Detecta automaticamente a URL correta baseado no hostname
 */

export const getBackendUrl = () => {
  const hostname = window.location.hostname;
  
  // Se estiver em meucardapiozap.top, usar essa URL
  if (hostname === 'meucardapiozap.top' || hostname === 'www.meucardapiozap.top') {
    return 'https://meucardapiozap.top';
  }
  
  // Se estiver em preview do Emergent
  if (hostname.includes('.preview.emergentagent.com')) {
    return `https://${hostname}`;
  }
  
  // Se estiver em produção do Emergent (.emergent.host)
  if (hostname.includes('.emergent.host')) {
    // Força usar meucardapiozap.top em produção
    return 'https://meucardapiozap.top';
  }
  
  // Fallback para variável de ambiente ou localhost
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Debug: Log da URL da API
console.log('🔧 BACKEND_URL:', BACKEND_URL);
console.log('🔧 API:', API);
console.log('🔧 Hostname:', window.location.hostname);

export default { BACKEND_URL, API, getBackendUrl };
